import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class StaffImportService {
  
  constructor(private apiService: ApiService,
    ) { }

  public GetImportTemplateList(): Observable<RestResponse> {
    const url = `${API.StaffImport.getImportTemplateList}`;    
    return this.apiService.get(url);
  }

  public GetColumnsForTemplate(id: number): Observable<RestResponse> {
    const url = `${API.StaffImport.getColumnsForTemplate}/${id}`;    
    return this.apiService.get(url);
  }

  public deleteImportTemplate(id: number): Observable<RestResponse> {
    const url = `${API.StaffImport.deleteImportTemplate}/${id}`;
    return this.apiService.delete(url);
  }

  public saveExcelImportTemplate(model: any): Observable<RestResponse> {
    const url = `${API.StaffImport.saveExcelImportTemplate}`;    
    return this.apiService.post(url, model, true);
  }

  public getEmpressaTreeViewById(selectedCompanyId: number): Observable<RestResponse> {
    let url = `${API.StaffImport.getEmpressaTreeViewById}/${selectedCompanyId}`;
    return this.apiService.get(url);
  }

  public SaveImportarEmpresa(model: any): Observable<RestResponse> {
    const url = `${API.StaffImport.saveImportarEmpresa}`;    
    return this.apiService.post(url, model, true);
  }

  public StaffExcelImport(model: any): Observable<RestResponse> {
    const url = `${API.StaffImport.staffExcelImport}`;  
    return this.apiService.post(url, model);
  }
}
